import Base from "./base.service.js";
import Vue from "vue";

export default class PurchaseOrder extends Base {
  constructor() {
    super("po");
  }

  checkPO(id) {
    return new Promise((resolve) => {
      Vue.axios
        .get(this.path + "check-po/" + id)
        .then((res) => {
          return resolve(res.data.data);
        })
        .catch(() => {});
    });
  }

  uploadFiles(files) {
    return new Promise((resolve) => {
      Vue.axios
        .post(this.path + "uploads/", files, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          return resolve(res.data.data);
        })
        .catch(() => {});
    });
  }

  uploadFile(file) {
    return new Promise((resolve) => {
      Vue.axios
        .post(this.path + "upload/", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          return resolve(res.data.data);
        })
        .catch(() => {});
    });
  }

  addReferenceNumber(poId, params) {
    return new Promise((resolve) => {
      Vue.axios
        .put(this.path + "ref-number/" + poId, params)
        .then((res) => {
          return resolve(res);
        })
        .catch(() => {});
    });
  }

  getMaintenanceDetail(poId) {
    return new Promise((resolve) => {
      Vue.axios
        .get(this.path + poId + "/maintenance")
        .then((res) => {
          return resolve(res.data || {});
        })
        .catch(() => {
          document.location.href = "/404";
        });
    });
  }

  editMaintenanceDetail(poId, params) {
    return new Promise((resolve) => {
      Vue.axios
        .patch(this.path + poId + "/maintenance", params)
        .then((res) => {
          return resolve(res);
        })
        .catch(() => {});
    });
  }

  editMaintenanceDetailAndSendZalo(poId, params) {
    return new Promise((resolve) => {
      Vue.axios
        .patch(this.path + poId + "/maintenance-save-send-zalo", params)
        .then((res) => {
          return resolve(res);
        })
        .catch(() => {});
    });
  }

  getRepairDetail(poId) {
    return new Promise((resolve) => {
      Vue.axios
        .get(this.path + poId + "/repair")
        .then((res) => {
          return resolve(res.data || {});
        })
        .catch(() => {
          document.location.href = "/404";
        });
    });
  }

  editRepairDetail(poId, params) {
    return new Promise((resolve) => {
      Vue.axios
        .patch(this.path + poId + "/repair", params)
        .then((res) => {
          return resolve(res);
        })
        .catch(() => {});
    });
  }

  // warehouse
  getDeliveryDetail(poId) {
    return new Promise((resolve) => {
      Vue.axios
        .get(this.path + poId + "/delivery")
        .then((res) => {
          return resolve(res.data || {});
        })
        .catch(() => {
          document.location.href = "/404";
        });
    });
  }

  editDelivery(poId, body) {
    return new Promise((resolve) => {
      Vue.axios
        .patch(this.path + poId + "/delivery", body)
        .then((res) => {
          return resolve(res);
        })
        .catch(() => {});
    });
  }
}
